<template>
  <SogFlexRow style="justify-content: space-between;padding-bottom: 10px">
    <span style="align-self: center;padding-left: 10px">
      <slot />
    </span>
    <SogIcon
      icon="mdi-close"
      style="margin-right: 10px;cursor: pointer"
      @click="onClick"
    />
  </SogFlexRow>
</template>

<script setup lang="ts">

import SogFlexRow from "@/shared/ui/SogFlexRow.vue";
import SogIcon from "@/shared/ui/SogIcon.vue";

const _emits = defineEmits(["close"])

function onClick() {
  _emits("close")
}



</script>

<style scoped>

</style>
